export const TITLE_BY_PATHNAME = {
  '/accounts': 'Accounts',
  '/campaigns': 'Campaigns',
  '/sequences': 'Sequences',
  '/inbox': 'Inbox',
  '/reports': 'Analytics',
  '/dashboard': 'Dashboard',
  '/coverage': 'Coverage',
  '/opportunities': 'Opportunities',
  '/myaccount': 'My account',
  '/account-confirm-email': 'Account confirm email',
  '/timelines': 'Timelines',
};

export default TITLE_BY_PATHNAME;
